import { z } from "zod";
import { LOCALE_VALUES } from "../enum.js";

export const updateProfileSchema = z
	.object({
		first_name: z.string().optional(),
		last_name: z.string().optional(),
		photo_url: z.string().optional(),
		nickname: z.string().max(40).optional(),
		show_nickname: z.boolean().optional(),
		expo_push_token: z.string().optional(),
		locale: z.enum(LOCALE_VALUES).optional(),
	})
	.strict();

export type UpdateProfilePayload = z.infer<typeof updateProfileSchema>;
